import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../global/components";
import strings from "../../../global/constants/StringConstants";
import urls from "../../../global/constants/UrlConstants";
import { doseUserHasPremiumFeatureAccess } from "../../../utils/AuthorizationManager";
import history from "../../../utils/history";
import PromoCodeDialog from "../Dialogs/PromoCodeDialog/PromoCodeDialog";
import premiumFeatureWrapperStyles from "./PremiumFeatureWrapper.styles";

interface PremiumFeatureWrapperProps {
  component: React.ReactNode;
  setIsLoading: (loading: boolean) => void;
}

const PremiumFeatureWrapper = ({
  component,
  setIsLoading,
}: PremiumFeatureWrapperProps) => {
  const classes = premiumFeatureWrapperStyles;
  const { t } = useTranslation();
  const hasPremiumAccess = doseUserHasPremiumFeatureAccess();
  const [openPromo, setOpenPromo] = useState<boolean>(false);

  if (hasPremiumAccess) {
    return <>{component}</>;
  }

  const getPromoCodeDialog = () => {
    return (
      <PromoCodeDialog
        open={openPromo}
        setOpen={setOpenPromo}
        setIsLoading={setIsLoading}
      />
    );
  };

  return (
    <>
      <Box sx={classes.wrapper}>
        <Box sx={classes.blurContainer}>{component}</Box>
        <Box sx={classes.overlayContainer}>
          <Box sx={classes.contentBox}>
            <Typography variant="h6" sx={classes.messageText}>
              {t("premiumFeatureMessage")}
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              <CustomButton
                label={t("upgradePlanHeader")}
                type={strings.PRIMARY}
                onClick={() => history.push(urls.pricingViewPath)}
                customClasses={classes.upgradeButton}
              />
              <CustomButton
                label={t("addNewPromoCode")}
                type={strings.SECONDARY}
                onClick={() => setOpenPromo(true)}
                customClasses={classes.upgradeButton}
              />
            </Stack>
          </Box>
        </Box>
      </Box>
      {getPromoCodeDialog()}
    </>
  );
};

export default PremiumFeatureWrapper;
